import { render, staticRenderFns } from "./add_mindset_page.vue?vue&type=template&id=d0af269a&scoped=true"
import script from "./add_mindset_page.vue?vue&type=script&lang=js"
export * from "./add_mindset_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0af269a",
  null
  
)

export default component.exports